<template>
  <section class="message__participant">
    <WIcon icon="icTeam" />
    <WParagraph>
      {{ message.content }}
    </WParagraph>
  </section>
</template>

<script>
import { WIcon, WParagraph } from '@alice-health/wonderland-vue'

export default {
  components: { WIcon, WParagraph },
  props: {
    message: { type: Object, default: undefined }
  }
}
</script>

<style lang="scss">
@import '@/style/_non-rendering';
.message__participant {
  @extend %body-small;
  align-items: center;
  color: var(--gl-color-shades-gray-60);
  display: flex;
  fill: var(--gl-color-shades-gray-90);
  gap: var(--gl-spacing-02);
  justify-content: center;
  padding: var(--gl-spacing-04);
}
</style>
